import { IReservation } from '../shared/interfaces/reservation.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';

class RetrieveReservationServiceClass {
    /**
     * Method to retrieve reservation
     * @param hotelCode
     * @param reservationCode
     * @param lastName
     * @param languageId
     */
    async retrieveReservation(hotelCode: number,
        reservationCode: number, lastName: string, languageId: string, currencyCode?: string, tcShareLocation?: boolean) {
        try {
            const retrieveReservationApiResponse: Response =
                await ApiService.retrieveReservation(hotelCode, reservationCode, lastName, languageId, currencyCode, tcShareLocation);
            const reservation: IReservation = await retrieveReservationApiResponse.json();
            return reservation;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
    /**
     * Method to retrieve reservation
     * @param hotelCode
     * @param confirmationId confirmationId will be in encrypted string
     * @param checkInDate check in date format 'yyy-mm-dd'
     * @param languageId
     * @param currencyCode
     * @param tcShareLocation
     * @returns reservation
     */
    async retrievePayByLinkReservation(hotelCode: number,
        confirmationId: string, checkInDate: string, currencyCode?: string, tcShareLocation?: boolean) {
        try {
            const retrieveReservationApiResponse: Response =
                await ApiService.retrievePayByLinkReservation(hotelCode,
                    confirmationId, checkInDate, currencyCode, tcShareLocation);
            const reservation: IReservation = await retrieveReservationApiResponse.json();
            return reservation;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const RetrieveReservationService = new RetrieveReservationServiceClass();
